import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { api, setTokens } from '../api.js'
import { Alert } from '../lib.jsx'

export default function VerifyEmail() {
  const [params] = useSearchParams()
  const nav = useNavigate()
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(true)
  const token = params.get('token')

  useEffect(() => {
    if (!token) { setErr('Brak tokenu weryfikacyjnego w linku'); setBusy(false); return }
    (async () => {
      try {
        const t = await api.verifyEmail(token)
        setTokens(t.access_token, t.refresh_token)
        nav('/', { replace: true })
      } catch (e) { setErr(e.message || 'Nie udało się potwierdzić adresu e-mail') } finally { setBusy(false) }
    })()
  }, [token])

  return (
    <div className="login-wrap">
      <div className="card login-card">
        <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
        {busy && <div className="tag" style={{ textAlign: 'center' }}><span className="spin-sm" style={{ marginRight: 8 }} />Potwierdzanie adresu e-mail…</div>}
        <Alert kind="err">{err}</Alert>
        {err && <Link to="/login" className="btn btn-primary" style={{ width: '100%', display: 'flex' }}>Przejdź do logowania</Link>}
      </div>
    </div>
  )
}
